import { useState, useEffect, useCallback, useRef } from "react";
import { MOCK } from "./MockData";
import { fmt, statusColor } from "./Utils/Utilities";
import { Badge, ActionMenu } from "./SharedUI";

function DeliveriesPage({ showToast: toast }) {
  const [deliveries, setDeliveries] = useState(MOCK.deliveries);
  const [filterStatus, setFilterStatus] = useState("All");

  const filtered = deliveries.filter(
    (d) => filterStatus === "All" || d.status === filterStatus,
  );

  const updateStatus = (del, status) => {
    setDeliveries((p) =>
      p.map((d) => (d.id === del.id ? { ...d, status } : d)),
    );
    toast(`${del.id} → ${status}`, "s");
    // API: API.deliveries.updateStatus(del.id, status)
  };

  const STATUS_FLOW_D = {
    Scheduled: ["In Transit", "Cancelled"],
    "In Transit": ["Delivered"],
    Unassigned: ["Scheduled"],
  };

  const stats = ["Delivered", "In Transit", "Scheduled", "Unassigned"].map(
    (s) => ({ s, n: deliveries.filter((d) => d.status === s).length }),
  );

  return (
    <div className="page">
      <div className="fc gap8 mb16">
        {stats.map((s) => (
          <div
            key={s.s}
            style={{
              background: "var(--surface)",
              border: `1px solid ${statusColor(s.s)}30`,
              borderRadius: 8,
              padding: "10px 16px",
              cursor: "pointer",
            }}
            onClick={() => setFilterStatus(s.s === filterStatus ? "All" : s.s)}
          >
            <div className="syne fw7 fs18" style={{ color: statusColor(s.s) }}>
              {s.n}
            </div>
            <div className="fs10 tc3">{s.s}</div>
          </div>
        ))}
      </div>

      <div className="panel">
        <div className="tbar">
          <span className="ph-title">Delivery Schedule</span>
          <select
            className="tfilter"
            style={{ marginLeft: "auto" }}
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            {[
              "All",
              "Scheduled",
              "In Transit",
              "Delivered",
              "Unassigned",
              "Cancelled",
            ].map((s) => (
              <option key={s}>{s}</option>
            ))}
          </select>
        </div>
        <table className="tbl">
          <thead>
            <tr>
              <th>Del. ID</th>
              <th>Order</th>
              <th>Customer</th>
              <th>Scheduled</th>
              <th>Driver</th>
              <th>Vehicle</th>
              
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((d) => (
              <tr key={d.id}>
                <td className="mono t-flame">{d.id}</td>
                <td className="mono tc2">{d.orderId}</td>
                <td
                  className="fs12"
                  style={{
                    maxWidth: 130,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {d.customer}
                </td>
                <td className="mono fs10 tc2">{fmt.date(d.scheduledDate)}</td>
                <td className="fs11 tc2">
                  {d.driver || (
                    <span style={{ color: "var(--danger)", fontSize: 11 }}>
                      Unassigned
                    </span>
                  )}
                </td>
                <td className="mono tc2 fs11">{d.vehicle || "—"}</td>
                
                <td>
                  <Badge status={d.status} />
                </td>
                <td>
                  <ActionMenu
                    items={[
                      ...(STATUS_FLOW_D[d.status] || []).map((s) => ({
                        icon: <i className="bi bi-arrow-repeat" />,
                        label: `→ ${s}`,
                        action: () => updateStatus(d, s),
                      })),
                      {
                        icon: <i className="bi bi-person" />,
                        label: "Assign Driver",
                        action: () => toast("Assign driver modal", "s"),
                      },
                    ]}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DeliveriesPage;
